module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_softbank-5a2e429b929021d44c29b6b126fc2274.png";